import React from "react";
import { useSignupAgencyMutation } from "../../redux/api/authApi";
import { useUploadImageMutation } from "../../redux/api/filesApi";
import { toast } from "react-toastify";
import AgencyProfileForm from "../../components/AgencyProfileForm";
import { usePostAgencyPkgDetailsMutation } from "../../redux/api/packagesApi";

export default function Signup() {
  const [uploadImage] = useUploadImageMutation();
  const [signupAgency, { isLoading }] = useSignupAgencyMutation();
  const [postAgencyPkgDetails] = usePostAgencyPkgDetailsMutation(); // ✅

  

  const onSubmit = async (data) => {


    let uploadedLogo = null;
    let uploadedWatermark = null;
    let uploadedLicensePic = null;

    let p1, p2, p3;

    if (data.agencylogo) {
      let logoFormData = new FormData();
      logoFormData.append("files", data.agencylogo);
      p1 = uploadImage({ image: logoFormData, imageType: "agencylogo", tag:"img" })
        .unwrap()
        .then((res) => (uploadedLogo = res));
    }

    if (data.agencywatermark) {
      let watermarkFormData = new FormData();
      watermarkFormData.append("files", data.agencywatermark);
      p2 = uploadImage({ image: watermarkFormData, imageType: "agencywm", tag:"img" })
        .unwrap()
        .then((res) => (uploadedWatermark = res));
    }

    if (data.agencylicensepic) {
      let licensePicFormData = new FormData();
      licensePicFormData.append("files", data.agencylicensepic);
      p3 = uploadImage({ image: licensePicFormData, imageType: "agencylicpic", tag:"img" })
        .unwrap()
        .then((res) => (uploadedLicensePic = res));
    }

    await Promise.all([p1, p2, p3]).then(async () => {
      let postData = data;
      postData.agencylogo = uploadedLogo ?? data.agencylogo;
      postData.agencywatermark = uploadedWatermark ?? data.agencywatermark;
      postData.agencylicensepic = uploadedLicensePic ?? data.agencylicensepic;
      postData.agencystatus = 0;

      try {
        // 1️⃣ Create agency
        const agencyRes = await signupAgency(postData).unwrap();
        toast.success(
          "Agency is registered. Please wait while we review your details."
        );

        await postAgencyPkgDetails({
          agencyid: agencyRes?.agencyId,
          pkgid: 1,
          purchaseSource: data.purchasesource,
          purchaseDate: new Date().toISOString(),
        }).unwrap();
      } catch (err) {
        if (err.status === 409)
          return toast.error("Agency Already Exists. Please login to continue");

        toast.error("Unknown error occurred, please try again later");
      }
    });
  };

  return (
    <div>
      <AgencyProfileForm onAddAgency={onSubmit} isSubmitting={isLoading} />
    </div>
  );
}
